<template>
  <basic-container>
    <avue-crud
            :option="option"
            :data="data"
            :page.sync="page"
            :search.sync="search"
            ref="crud"
            @row-del="rowDel"
            v-model="form"
            :permission="permissionList"
            @row-update="rowUpdate"
            @row-save="rowSave"
            :before-open="beforeOpen"
            @search-change="searchChange"
            @search-reset="searchReset"
            @refresh-change="refreshChange"
            @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad">
      <template slot="enAble" slot-scope="scope">
        {{scope.row.enAble === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            @change="switchChange($event, scope.row)"
            v-if="permission.user_useryy_edit"
            v-model="scope.row.enAble">
        </el-switch>
      </template>
      <template slot="enAbleForm">
        {{form.enAble === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            v-model="form.enAble">
        </el-switch>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import mixin from '@/util/mixin'
import { enAble } from '@/api/user/useryy'

export default {
  mixins: [mixin],
  data () {
    return {
      module: 'user/useryy',
      form: {},
      search: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        searchMenuSpan: 5,
        columnBtn: false,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        labelWidth: 140,
        align: 'center',
        column: [
          {
            label: '姓名',
            prop: 'xm',
            search: true,
            rules: [{
              required: true,
              message: '请输入姓名'
            }]
          },
          {
            label: '用户平台账户',
            prop: 'username'
          },
          {
            label: '用友平台密码',
            prop: 'password'
          },
          {
            label: '是否可用',
            prop: 'enAble',
            viewDisplay: false,
            editDisplay: false,
            slot: true,
            formslot: true
          },
          {
            label: '区域',
            prop: 'area',
            type: 'select',
            search: true,
            dicUrl: '/sys/dict/code/area',
            rules: [{
              required: true,
              message: '请选择区域'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    permissionList () {
      return {
        addBtn: this.permission.user_useryy_add ? this.permission.user_useryy_add : false,
        viewBtn: this.permission.user_useryy_view ? this.permission.user_useryy_view : false,
        delBtn: this.permission.user_useryy_delete ? this.permission.user_useryy_delete : false,
        editBtn: this.permission.user_useryy_edit ? this.permission.user_useryy_edit : false
      }
    }
  },
  methods: {
    switchChange ($event, row) {
      let msg = '***'
      if (row.enAble === '0') {
        msg = '确定设置为可用？'
      } else if (row.enAble === '1') {
        msg = '确定关闭可用？'
      }
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        enAble(row).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            row.enAble = row.enAble === '1' ? '0' : '1'
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function (e) {
        if (e === 'cancel' || e === 'close') {
          row.enAble = row.enAble === '1' ? '0' : '1'
        }
      })
    }
  }
}
</script>
